import React from "react";
import { bool, node, oneOf, string } from "prop-types";
import Section from "../Section";
import Line from "../Line";
import { Col, Container, Row } from "../Grid";
import { classes } from "../utils/classes";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";

const PageNavbar = ({
	bgColor = "6",
	alignHorizontal = "center",
	withBorder = false,
	sticky = false,
	isFluid = false,
	fullWidthBorder = false,
	children,
	utility = { ...utilityProps },
	spacing = { ...spacingProps },
}) => (
	<Section
		className={classes(
			...utilityClassName(
				deepMergeProps(
					{
						bgColor,
						...(fullWidthBorder
							? { lg: { border: { bottom: { width: 1, color: "black--15" } } } }
							: {}),
					},
					pureProps(utility),
				),
			),
			...spacingClassName(spacing),
			sticky && "page-navbar--sticky",
		)}
	>
		<Container isFluid={isFluid}>
			<Row>
				<Col>
					<div className={classes("page-navbar", `align-horizontal--${alignHorizontal}`)}>
						{children}
					</div>
				</Col>
			</Row>
			{withBorder ? <Line /> : null}
		</Container>
	</Section>
);

PageNavbar.propTypes = {
	alignHorizontal: oneOf(["start", "end", "center", "between", "around"]),
	children: node,
	isFluid: bool,
	sticky: bool,
	fullWidthBorder: bool,
	bgColor: string,
	withBorder: bool,
	utility: utilityPropTypes,
	spacing: spacingPropTypes,
};

export default PageNavbar;
